module.exports = {"130423100":"临漳镇","130423101":"南东坊镇","130423102":"孙陶集镇","130423103":"柳园镇","130423104":"称勾集镇","130423105":"邺城镇","130423106":"章里集镇","130423200":"狄邱乡","130423201":"张村集乡","130423202":"西羊羔乡","130423204":"杜村集乡","130423206":"习文乡","130423207":"砖寨营乡","130423208":"柏鹤集乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130423.json
// module id = 116
// module chunks = 0